import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateData } from '../../store/slices/optionSlice';
import { Watch } from 'react-loader-spinner';
import Loader from 'react-loader-advanced';
import { useNavigate } from 'react-router-dom';

import PageWrapper from '../../components/PageWrapper';
import Header from '../../components/Header';
import Contact from '../../components/Contact';
import CalculateTable from '../../components/CalculateTable';
import SalesmanOwner from '../../components/SalesmanOwner';
import Footer from '../../components/Footer';
import Content from '../../components/Content';
import SalesPersonOwner from '../../components/SalesPersonOwner';
import Operation from '../../components/Operation';
import PageTitle from '../../components/PageTitle';
import Paragraph from '../../components/Paragraph';
import Information from '../../components/Information';
import BottomOfPage3 from '../../components/BottomOfPage3';
import MiddleOfPage3 from '../../components/MiddleOfPage3';
import WindowTable from '../../components/WindowTable';
import MeasureSheet from '../../components/MeasureSheet';
import WindowOrder from '../../components/WindowOrder';
import SalesConsultant from '../../components/SalesConsultant';
import PatioDoorOrder from '../../components/PatioDoorOrder';
import CreditCardForm from '../../components/CreditCardForm';
import EasyToPay from '../../components/EasyToPay';
import { useAuthDataContext } from '../../components/AuthProvider';

import styled from 'styled-components';
import '../../styles/base.css';
import '../../App.css';

const AppWrapper = styled.div`
  padding: 100px 0 0 0;
  background-color: black;
`;

const Page1 = () => {
  return (
    <div className="page" id="page1">
      <Header />
      <Contact />
      <CalculateTable isInputEnable={true} />
      <SalesmanOwner />
      <Footer />
    </div>
  );
};

const Page2 = () => {
  return (
    <div className="page" id="page2">
      <PageTitle>
        <div className="page_title">
          PREPARING FOR YOUR NEW WINDOWS AND DOORS
        </div>
      </PageTitle>
      <Content />
      <SalesPersonOwner />
      <Paragraph>
        <span
          style={{ fontStyle: 'italic', fontWeight: 'bold', fontSize: '1.2em' }}
        >
          P.S. Now would be a good time to review contract with the salesman to
          be sure of your order options and work to be done. Only the items and
          services on the contract will be done. If you have any questions
          whatsoever, now is the time to ask.
        </span>
      </Paragraph>
      <Paragraph style={{ marginTop: '40px', textAlign: 'left' }}>
        {window.location.host.split('.')[0] !== 'demo' && (
          <small className="text-red">
            Louisville Window 03-22 Valid-30 days
          </small>
        )}
      </Paragraph>
    </div>
  );
};

const Page3 = () => {
  const colNames = [
    'No.',
    'Room',
    'Style',
    'Grids',
    'LE',
    'Size',
    'Mull',
    'Window Note',
  ];
  return (
    <div className="page" id="page3">
      <Information />
      <WindowTable
        isInputEnable={false}
        colNames={colNames}
        rowCount={29}
        firstNoOfRow={1}
      />
      <MiddleOfPage3 />
      <BottomOfPage3 />
    </div>
  );
};

const Page4 = () => {
  const colNames = [
    'No.',
    'Room',
    'Style',
    'Grids',
    'LE',
    'Size',
    'Mull',
    'Window Note',
  ];
  return (
    <div className="page" id="page4">
      <Information />
      <WindowTable
        isInputEnable={false}
        colNames={colNames}
        rowCount={49}
        firstNoOfRow={30}
      />
    </div>
  );
};

const Page5 = () => {
  return (
    <div className="page" id="page5">
      <EasyToPay />
    </div>
  );
};

const MeasureSheetPage = () => {
  return (
    <div>
      <PageWrapper addClass="page">
        <MeasureSheet page={1} />
      </PageWrapper>
      <PageWrapper addClass="page">
        <MeasureSheet page={2} />
      </PageWrapper>
    </div>
  );
};

const WindowOrderPage = () => {
  return (
    <PageWrapper addClass="page">
      <WindowOrder />
    </PageWrapper>
  );
};

const SalesConsultantPage = () => {
  return (
    <PageWrapper addClass="page">
      <SalesConsultant />
      <div className="hr-line">COPY</div>
      <SalesConsultant />
    </PageWrapper>
  );
};

const PatioDoorOrderPage = () => {
  return (
    <PageWrapper addClass="page">
      <PatioDoorOrder />
    </PageWrapper>
  );
};

const CreditCardPage = () => {
  return (
    <PageWrapper addClass="page">
      <CreditCardForm />
    </PageWrapper>
  );
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
}

const HomePage = () => {
  const navigate = useNavigate();
  const { authData, isdemo } = useAuthDataContext();
  useEffect(() => {
    if (!isdemo && !authData.email) {
      navigate('/');
    }
  }, [authData, isdemo]);

  useWindowDimensions();
  const windowInnerWidth = useRef(window.innerWidth);
  const loading = useSelector((state) => state.operation.loading);
  const dispatch = useDispatch();
  dispatch(updateData({ dataKey: 'viewMode', data: 'homepage' }));

  const style = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  const spinner = (
    <div style={style}>
      <Watch
        height="80"
        width="80"
        radius="48"
        color="#4fa94d"
        ariaLabel="watch-loading"
        visible={true}
      />
    </div>
  );

  //  console.log('???=>window.innerWidth using useRef:', windowInnerWidth.current);
  //  console.log('window.innerWidth', window.innerWidth);

  return !isdemo && !authData.email ? (
    <></>
  ) : (
    <>
      <Loader
        backgroundStyle={{ backgroundColor: 'rgba(0, 0, 0, 0)' }}
        show={loading === 'pending' ? true : false}
        message={spinner}
      >
        <div
          className="App"
          style={{ transform: `scale(${windowInnerWidth.current / 1366})` }}
        >
          <AppWrapper id="appwrapper">
            <Loader show={loading === 'pending' ? true : false} message={<></>}>
              <Page1 />
              <Page2 />
              <Page5 />
              <MeasureSheetPage />
              <WindowOrderPage />
              <PatioDoorOrderPage />
              <CreditCardPage />
            </Loader>
          </AppWrapper>
        </div>
      </Loader>
      <Operation />
    </>
  );
};

export default HomePage;
